<template>
	<div class="addpropertyManage">
		<el-form :rules="rules" ref="form" :model="form" :label-width="require('@/config/enum').c_ws4" :label-suffix="require('@/config/enum').c_colon">
			<el-card>
				<div class="jump-btn">
					<el-button type="primary" @click="jump()">{{$t('lang.btn_backaddpropertyManage')}}</el-button>
				</div>
				<el-form-item :label="$t('lang.lab_phoneNum')" prop="userName" v-if="this.id===''" class="formcontent">
					<el-input @input="keyBAuserName" v-model="form.userName" maxlength="11" :placeholder="$t('lang.lab_selectPhoneNum')"></el-input>
				</el-form-item>
				<el-form-item :label="$t('lang.lab_Adminpassw')" prop="pwd" class="formcontent">
					<el-row>
						<el-col :span="18">
									<el-input v-model="form.pwd" type="password" maxlength="20" :placeholder="$t('lang.pla_Adminpassw')" :disabled="this.id!=''"></el-input>
						</el-col>
						<el-col :span="6"  v-if="this.id!=''">
										<el-button  class="btn-first" type="primary" @click="resetPassword('form')">{{$t('lang.lab_resetPassword')}}</el-button>
						</el-col>
					</el-row>
				</el-form-item>
				<el-form-item v-if="this.id!=''" :label="$t('lang.lab_phoneNum')" prop="mobile" class="formcontent">
					<el-input v-model="form.mobile"></el-input>
				</el-form-item>
				<el-form-item :label="$t('lang.lab_gender')" prop="gender">
					<el-radio-group v-model="form.gender">
						<el-radio v-for="(item,index) in genderlist" :label="item.id" :key="index">{{item.name}}</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item :label="$t('lang.lab_review')" prop="review">
					<el-radio-group v-model="form.review">
						<el-radio v-for="(item,index) in reviewlist" :label="item.id" :key="index">{{item.name}}</el-radio>
					</el-radio-group>
				</el-form-item>
				<!-- <el-form-item :label="$t('lang.lab_typeManage')" prop="type">
					<el-radio-group v-model="form.type">
						<el-radio v-for="(item,index) in typelist" :label="item.id" :key="index">{{item.name}}</el-radio>
					</el-radio-group>
				</el-form-item> -->
				<!-- <el-form-item :label="$t('lang.lab_HouseUnit')" v-if="form.type==2">
					<el-button @click="HouseUnit()">{{$t('lang.lab_Houselist')}}</el-button>
				</el-form-item> -->
				<el-form-item v-if="this.id==''" label="职务" prop="jobName" class="formcontent">
					<el-input v-model="form.jobName" maxlength="20" placeholder="请输入职务（搭配姓名展示用,例：工程）"></el-input>
				</el-form-item>
				<el-form-item :label="$t('lang.lab_Adminnickname')" prop="idNo" class="formcontent">
					<el-input v-model="form.idNo" maxlength="20" placeholder="请输入姓名"></el-input>
				</el-form-item>
				<el-form-item :label="$t('lang.lab_dept')" prop="dept" class="formcontent">
					<el-select v-model="form.dept">
						<el-option v-for="(item,index) in deptlist" :key="index" :label="item.name" :value="item.id"></el-option>
					</el-select>
					<el-tooltip class="item" effect="light" content="该部门选择请到'部门管理'中配置" placement="right">
              <el-button class="noStyle"><i class="el-icon-warning-outline tipIcon"></i></el-button>
            </el-tooltip>
				</el-form-item>
				<el-form-item :label="$t('lang.lab_workYears')" prop="workYears" class="formcontent">
					<el-input v-model="form.workYears" maxlength="2" :placeholder="$t('lang.pla_workYears')" @input="keyBA">
					</el-input>
				</el-form-item>
				<el-form-item :label="$t('lang.lab_joinDate')" prop="joinDate" class="formcontent">
					<el-date-picker v-model="form.joinDate" type="date" value-format="timestamp" :placeholder="$t('lang.lab_joinDate')"></el-date-picker>
				</el-form-item>
				<el-form-item :label="$t('lang.lab_operationNum')" class="formcontent">
					<el-input v-model="form.operationNum"  :placeholder="$t('lang.lab_pla_operationNum')">
					</el-input>
				</el-form-item>
				<!-- 选择职务 -->
				<el-card v-if="rolelist.length>0" >
					<el-collapse v-model="activeNames" prop="checkedrole">
						<el-form-item :label="$t('lang.lab_position')">
							<el-collapse-item prop="checkedrole">
								<div class="chooseActive">
									<el-checkbox v-model="roleCheckAll" @change="handleRoleCheckAllChange">全选</el-checkbox>
									<br/>
									<el-checkbox v-model="item.roleischeck" v-for="item in rolelist" :label="item.Id" :key="item.Id" :title="item.Name">{{item.Name}}</el-checkbox>
								</div>
							</el-collapse-item>
						</el-form-item>
					</el-collapse>
				</el-card>
				<!-- 岗位属性 -->
				<el-card v-if="authorityList.length>0" style="display:none;">
					<el-collapse v-model="activeNames">
						<el-form-item :label="item.Name" :prop="item.Name" class="check-group" v-for="(item, index) in authorityList"
						:key="index" :name="index">
							<el-collapse-item>
								<div v-if="item.AuthorityType === 1" class="chooseActive">
									<el-checkbox v-model="subitem.CheckFlag" v-for="(subitem, i) in item.children" :key="i">
										{{subitem.OptionName}}</el-checkbox>
								</div>
								<div v-if="item.AuthorityType === 0">
									<el-radio-group v-model="radioArray[index]">
										<el-radio v-for="(subitem, i) in item.children" :key="i" :label="subitem" @change="handleRadioChanges(i,subitem)"
										:title="subitem.OptionName">{{subitem.OptionName}}
										</el-radio>
									</el-radio-group>
								</div>
							</el-collapse-item>
						</el-form-item>
					</el-collapse>
				</el-card>
				<!-- 权限分配 -->
				<el-card v-if="permissionlist.length>0">
					<el-collapse v-model="activeNames" prop="checkedpermission">
						<el-form-item :label="$t('lang.lab_permission')">
							<el-collapse-item prop="checkedpermission">
								<div class="chooseActive">
									<el-checkbox v-model="permissionCheckAll" @change="handlePermissionCheckAllChange">全选</el-checkbox>
									<br/>
									<el-checkbox v-model="item.permissioncheck" v-for="item in permissionlist" :label="item.id" :key="item.id"
									:title="item.name">{{item.name}}</el-checkbox>
								</div>
							</el-collapse-item>
						</el-form-item>
					</el-collapse>
				</el-card>
				<!-- 所属小区 -->
				<el-card class="garden">
					<el-collapse v-model="activeNames">
						<el-form-item prop="gardenIds" :label="$t('lang.lab_Admingarden')">
							<el-collapse-item>
								<el-checkbox v-model="gardenCheckAll" @change="handleGardenCheckAllChange">全选</el-checkbox>
								<el-checkbox-group v-model="form.gardenIds" class="chooseActive">
									<el-checkbox v-for="item in gardenlist" :label="item.id" :key="item.id" :title="item.name" @change="gardenIdChange">{{item.name}}</el-checkbox>
								</el-checkbox-group>
							</el-collapse-item>
						</el-form-item>
					</el-collapse>
				</el-card>
				<!-- 门禁权限分配 -->
				<el-card class="garden">
					<el-collapse>
						<el-form-item label="门禁梯控权限" prop="staffDoor">
							<el-collapse-item>
								<el-checkbox-group v-model="staffDoor" class="chooseActive">
									<el-checkbox v-for="(item,index) in gardenlist" :label="item.id" :key="index" :title="item.name" :disabled="form.gardenIds.includes(item.id)">{{item.name}}</el-checkbox>
								</el-checkbox-group>
							</el-collapse-item>
						</el-form-item>
					</el-collapse>
				</el-card>
				<!-- 员工目标值 -->
				<!-- <el-card class="garden">
					<el-collapse>
						<el-form-item :label="$t('lang.lab_targetValue')">
							<el-collapse-item>
								<el-form-item class="targetLabel" label="年份">
									<el-date-picker @change="changeYear()" v-model="form.targetYear" type="year" :placeholder="$t('lang.lab_changeYear')">
									</el-date-picker>
								</el-form-item>
								<el-form-item v-show="form.targetYear">
									<el-form-item class="targetLabel" label="1月">
										<el-input @input=targetKeyup1() class="targetMonth" v-model="form.month1" :placeholder="$t('lang.lab_targetMonth1')"></el-input>
									</el-form-item>
									<el-form-item class="targetLabel" label="2月">
										<el-input @input=targetKeyup2() class="targetMonth" v-model="form.month2" :placeholder="$t('lang.lab_targetMonth2')"></el-input>
									</el-form-item>
									<el-form-item class="targetLabel" label="3月">
										<el-input @input=targetKeyup3() class="targetMonth" v-model="form.month3" :placeholder="$t('lang.lab_targetMonth3')"></el-input>
									</el-form-item>
									<el-form-item class="targetLabel" label="4月">
										<el-input @input=targetKeyup4() class="targetMonth" v-model="form.month4" :placeholder="$t('lang.lab_targetMonth4')"></el-input>
									</el-form-item>
									<el-form-item class="targetLabel" label="5月">
										<el-input @input=targetKeyup5() class="targetMonth" v-model="form.month5" :placeholder="$t('lang.lab_targetMonth5')"></el-input>
									</el-form-item>
									<el-form-item class="targetLabel" label="6月">
										<el-input @input=targetKeyup6() class="targetMonth" v-model="form.month6" :placeholder="$t('lang.lab_targetMonth6')"></el-input>
									</el-form-item>
									<el-form-item class="targetLabel" label="7月">
										<el-input @input=targetKeyup7() class="targetMonth" v-model="form.month7" :placeholder="$t('lang.lab_targetMonth7')"></el-input>
									</el-form-item>
									<el-form-item class="targetLabel" label="8月">
										<el-input @input=targetKeyup8() class="targetMonth" v-model="form.month8" :placeholder="$t('lang.lab_targetMonth8')"></el-input>
									</el-form-item>
									<el-form-item class="targetLabel" label="9月">
										<el-input @input=targetKeyup9() class="targetMonth" v-model="form.month9" :placeholder="$t('lang.lab_targetMonth9')"></el-input>
									</el-form-item>
									<el-form-item class="targetLabel" label="10月">
										<el-input @input=targetKeyup10() class="targetMonth" v-model="form.month10" :placeholder="$t('lang.lab_targetMonth10')"></el-input>
									</el-form-item>
									<el-form-item class="targetLabel" label="11月">
										<el-input @input=targetKeyup11() class="targetMonth" v-model="form.month11" :placeholder="$t('lang.lab_targetMonth11')"></el-input>
									</el-form-item>
									<el-form-item class="targetLabel" label="12月">
										<el-input @input=targetKeyup12() class="targetMonth" v-model="form.month12" :placeholder="$t('lang.lab_targetMonth12')"></el-input>
									</el-form-item>
								</el-form-item>
							</el-collapse-item>
						</el-form-item>
					</el-collapse>
				</el-card> -->
				<el-form-item :label="$t('lang.lab_note')" prop="note" class="padtop-10 formcontent1">
					<el-input v-model="form.note" maxlength="100" :placeholder="$t('lang.pla_note')"></el-input>
				</el-form-item>
				<el-form-item label="选择/上传图片" prop="avatarUri" ref="avatarUri">
					<div style="color: cornflowerblue;font-weight: bold;">请选择默认形象头像或手动上传图片</div>
					<div class="defaultAvatarList">
						<div class="defaultAvatarBox" v-for="(item,index) in defaultAvatar" :key="index" @click="selectDefaultAvatar(item.url,index)">
							<el-image v-show="defaultAvatarIndex===index" class="selectIcon" src="https://oss.kmyhwy.cn/2025/03/17/42779c20-74c9-4ef7-a55b-05cade4708d4.png"></el-image>
							<el-image class="defaultAvatarImg" :src="item.url" ></el-image>
							<p class="defaultAvatarName" :class="defaultAvatarIndex===index?'selectFont':''">{{item.name}}</p>
						</div>
						<div class="handUpload" @click="handUpload">手动上传</div>
					</div>
					
					<upload-file v-show="showUpload" ref="uploading" :accept='accept' upTypes='1' :fileList='fileList' :clears='clears' @outputFile="getFile" @removeFile='removeFile'></upload-file>
				</el-form-item>
				<el-button class="btn-first" @click="resetForm('form')">{{$t('lang.btn_rest')}}</el-button>
				<el-button :disabled="total===0" class="detailbtn" type="primary" @click="save('form')">{{$t('lang.btn_save')}}
				</el-button>
			</el-card>
		</el-form>
		<!-- <el-dialog :visible.sync="show" :close-on-click-modal="false" center top="130px" width="600px" :title="title" @closed="handleDialogClosed">
			<el-scrollbar>
				<el-form class="trees" :rules="rules" ref="form" :model="form" :label-width="require('@/config/enum').c_ws4"
				:label-suffix="require('@/config/enum').c_colon">
					<el-tree node-key="unitId" ref="tree" :data="unitlist" show-checkbox :props="defaultProps" :default-checked-keys="unitlistcheck"></el-tree>
				</el-form>
			</el-scrollbar>
		</el-dialog> -->
	</div>
</template>
<script>
	/**
	 *@ClassName:addpropertyManage
	 *@Description:物业人员详情
	 *@author:孙斯维
	 *@Copyright:格众科技
	 *@date:2020-03-17
	 */
	import _ from 'lodash'
	import UploadFile from '../../../components/upload_file.vue'
	import { mapGetters } from 'vuex'

	export default {
		data() {
			var phone = /^1(?:3\d|4[4-9]|5[0-35-9]|6[67]|7\d|8\d|9\d)\d{8}$/
			var isPhone = (rule, value, callback) => {
				if (value === '') {
					callback(
						new Error(
							this.$i18n.t('lang.lab_please_Input') +
							this.$i18n.t('lang.lab_phoneNum')
						)
					)
				} else if (!phone.test(value)) {
					callback(
						new Error(this.$i18n.t('lang.lab_inputDutyPersonPhoneIsTrue'))
					)
				} else {
					if (this.form.userName != this.form.mobile) {
						this.checkMobileOrUserNameIsExist().then(res => {
							if (res) {
								callback(new Error(this.$i18n.t('lang.mobile_FALSE')))
							} else {
								callback()
							}
						})
					} else {
						callback()
					}
				}
			}
			var validatePass = (rule, value, callback) => {
				if (value === '') {
					callback(
						new Error(
							this.$i18n.t('lang.lab_please_Input') +
							this.$i18n.t('lang.lab_password')
						)
					)
				} else if (value.length < 6 || value.length > 15) {
					callback(
						new Error(
							this.$i18n.t('lang.lab_please_Input') +
							this.$i18n.t('lang.lab_frSixToFifteen')
						)
					)
				} else {
					callback()
				}
			}
			var validateStaffDoor = (rule, value, callback) => {
				if (this.staffDoor.toString() == '' || this.staffDoor.toString() == null || this.staffDoor.toString() ==
					undefined) {
					callback(new Error(
						this.$i18n.t('lang.lab_please_Input') +
						this.$i18n.t('lang.lab_staffDoorAuthority')
					))
				} else {
					callback()
				}
				/* if (this.staffDoor.toString() != '' || this.staffDoor.toString() != null || this.staffDoor.toString() != undefined) {
					callback()
				} else {
					callback(new Error(
							this.$i18n.t('lang.lab_please_Input') +
								this.$i18n.t('lang.lab_staffDoorAuthority')
						))
				} */
			}
			return {
				accept: '.jpg, .jpeg, .png',
				fileList: [], // 图片上传
				clears: false, // 清空按钮
				authoritySaveData: '', // 管理职责存储json字符串
				radioSaveData: '', // 管理单选集合
				shoarr: [], // 存到这个数组里进行去重操作--暂无该需求
				authorityList: [], // 所有职责
				radioArray: [], // 这个是必须的，选中的每一个职责的数据都会存在这个数组里去，没有这个会有问题
				gardenIds: [], // 小区id绑定
				defaultProps: {
					children: 'nodes',
					label: 'text'
				},
				title: this.$i18n.t('lang.houseUnittitle'), // 楼号/单元title
				show: false, // 弹框开关
				saveData: '', // 存储json字符串
				gardensaveData: '', // 小区存储json字符串
				stationsaveData: '', // 岗位存储json字符串
				rolesaveData: '', // 职务存储json字符串
				permissionsaveData: '', // 权限分配存储json字符串
				unitsaveData: '', // 区域存储json字符串
				isDisabled: 0, // 保存的可点击
				isDisabled1: 0, // 保存的可点击
				isDisabled2: 0, // 保存的可点击
				isDisabled3: 0, // 保存的可点击
				isDisabled4: 0, // 保存的可点击
				isDisabled5: 0, // 保存的可点击
				form: {
					userName: '',
					mobile: '',
					pwd: '',
					gender: '',
					review: '',
					// type: '',
					idNo: '',
					avatarUri: '',
					dept: '',
					workYears: '',
					joinDate: '',
					jobName: '', // 职务名称（搭配姓名展示用）
					/* targetYear: '', // 目标年份
					month1: 0, // 1月目标值
					month2: 0, // 2月目标值
					month3: 0, // 3月目标值
					month4: 0, // 4月目标值
					month5: 0, // 5月目标值
					month6: 0, // 6月目标值
					month7: 0, // 7月目标值
					month8: 0, // 8月目标值
					month9: 0, // 9月目标值
					month10: 0, // 10月目标值
					month11: 0, // 11月目标值
					month12: 0, // 12月目标值 */
					note: '',
					operationNum: '',
					gardenIds: [] // 小区id绑定
				}, // 查询对象

				staffDoor: [], // 小区门禁权限
				staffDoorSaveData: '', // 存储门禁权限字符串
				staffDoorIsDisable: false, // 门禁权限禁用

				rules: {
					gardenIds: [{
						type: 'array',
						required: true,
						message: this.$i18n.t('lang.check_garden'),
						trigger: 'change'
					}],
					userName: [{
						required: true,
						validator: isPhone,
						trigger: 'blur'
					}],
					mobile: [{
						required: true,
						validator: _.debounce(isPhone, 300),
						trigger: 'blur'
					}],
					pwd: [{
						required: true,
						validator: validatePass,
						trigger: 'blur'
					}],
					gender: [{
						required: true,
						message: this.$i18n.t('lang.lab_please_Select') +
							this.$i18n.t('lang.lab_gender'),
						trigger: 'change'
					}],
					review: [{
						required: true,
						message: this.$i18n.t('lang.lab_please_Select') +
							this.$i18n.t('lang.lab_review'),
						trigger: 'change'
					}],
					/* type: [{
						required: true,
						message: this.$i18n.t('lang.lab_please_Select') +
							this.$i18n.t('lang.lab_typeManage'),
						trigger: 'change'
					}], */
					idNo: [{
						required: true,
						message: this.$i18n.t('lang.lab_please_Input') +
							this.$i18n.t('lang.lab_propertyname'),
						trigger: 'blur'
					}],
					dept: [{
						required: true,
						message: '请选择部门',
						trigger: 'change'
					}],
					avatarUri: [{
						required: true,
						message: this.$i18n.t('lang.lab_please_Upload') +
							this.$i18n.t('lang.lab_uploadPhotograph'),
						trigger: 'change'
					}],
					staffDoor: [{
						required: true,
						validator: validateStaffDoor,
						trigger: 'change'
					}],
					jobName: [{
						required: true,
						message: '请输入职务',
						trigger: 'blur'
					}],
				}, // 表单验证
				genderlist: this.$i18n.t('lang.propertyManage.gender'), // 性别LIST
				reviewlist: this.$i18n.t('lang.propertyManage.review'), // 审阅权限LIST
				// typelist: this.$i18n.t('lang.propertyManage.type'), // 管家身份LIST
				deptlist: [], // 部门list
				gardenlist: [], // 所有小区
				// stationlist: [], // 岗位list
				stationcheck: '', // 岗位绑定值
				backsuccess: 0, // 查询对象返回
				activeNames: [],
				checkedrole: '', // 职务绑定值
				rolelist: [], // 职务list
				id: '', // 区别新增还是修改
				permissionlist: [], // 权限分配list
				permissioncheck: '', // 权限分配绑定值
				gardenischecks: [], // 选中保存小区id
				maintainTypechecks: [], // 选中保存权限分配id
				// unitlist: [], // 管辖list
				// unit: [], // 管辖选择list
				// unitnum: 0, // 管辖num
				// unitlistcheck: [], // 选中管辖
				// units: [], // 保存用管辖list
				// changeunit: [] // 关闭弹窗获取管辖list
				defaultAvatar: [
					{
						name: '管理（女）',
						url: 'http://oss.kmyhwy.cn/2025/07/31/3f5e14f4-c045-4b9e-b205-498367cf5a5b.png'
					},
					{
						name: '管理（男）',
						url: 'http://oss.kmyhwy.cn/2025/07/31/e95d52de-93bc-4b6c-a209-702d077b1848.png'
					},
					{
						name: '客服（女）',
						url: 'http://oss.kmyhwy.cn/2025/07/31/f687a543-daa6-479c-b148-426807f328a3.png'
					},
					{
						name: '客服（男）',
						url: 'http://oss.kmyhwy.cn/2025/07/31/27f8c99f-eeed-4765-be51-5c52938f3d50.png'
					},
					{
						name: '工程（女）',
						url: 'http://oss.kmyhwy.cn/2025/07/31/a3aab7fe-8706-4dff-89cc-2d47aa612c2e.png'
					},
					{
						name: '工程（男）',
						url: 'http://oss.kmyhwy.cn/2025/07/31/ad6f6ec0-9867-4846-90a1-f0fd6d5733b5.png'
					},
					{
						name: '保安（女）',
						url: 'http://oss.kmyhwy.cn/2025/07/31/57b07ce2-e4fd-46af-b856-0905b4f67e97.png'
					},
					{
						name: '保安（男）',
						url: 'http://oss.kmyhwy.cn/2025/07/31/0f94c5b5-0652-402b-adf5-546f3571e864.png'
					},
					{
						name: '保洁（女）',
						url: 'http://oss.kmyhwy.cn/2025/07/31/9c7d7516-3aac-41f8-9b58-7d203390a723.png'
					},
					{
						name: '保洁（男）',
						url: 'http://oss.kmyhwy.cn/2025/07/31/359b4bd5-5052-4dae-824b-8ec6f7d32c49.png'
					},
				],	// 默认头像图片list
				defaultAvatarIndex: '', // 默认头像角标
				showUpload: false, // 自动上传图片展示状态（上传图片是否展示）
				roleCheckAll: false, // 职务全选状态
				permissionCheckAll: false, // 权限分配全选状态
				gardenCheckAll: false, // 所属小区全选状态
			}
		},
		computed: {
			...mapGetters(['gardenId', 'staffId']),
			total: function() {
				if (this.radioArray.length === 0 && this.authorityList.length === 0) {
					return this.isDisabled + this.isDisabled1 + this.isDisabled3
				} else if (
					this.radioArray.length === 0 &&
					this.authorityList.length != 0
				) {
					return (
						this.isDisabled +
						this.isDisabled1 +
						this.isDisabled3 +
						this.isDisabled2
					)
				} else if (
					this.radioArray.length != 0 &&
					this.authorityList.length === 0
				) {
					return (
						this.isDisabled +
						this.isDisabled1 +
						this.isDisabled3 +
						this.isDisabled5
					)
				} else {
					return (
						this.isDisabled +
						this.isDisabled1 +
						this.isDisabled2 +
						this.isDisabled3 +
						this.isDisabled5
					)
				}
			}
		},
		watch: {
			// 切换小区，重新查询管辖区域，否则只查询一次
			gardenId: {
				handler(newVal, oldVal) {
					this.unitnum = 0
				},
				deep: true,
				immediate: true
			},
			backsuccess() {
				if (this.backsuccess === 1) {
					this.gardens()
					this.maintainTypes()
				}
			},
			form: {
				handler(newVal, oldVal) {
					for (var j = 0; j < newVal.gardenIds.length - 1; j++) {
						for (var i = 0; i < newVal.gardenIds.length - 1; i++) {
							if (newVal.gardenIds[i] > newVal.gardenIds[i + 1]) {
								var temp = newVal.gardenIds[i]
								newVal.gardenIds[i] = newVal.gardenIds[i + 1]
								newVal.gardenIds[i + 1] = temp
							}
						}
					}
					let tempRule = JSON.stringify(newVal)
					if (tempRule === this.saveData) {
						this.isDisabled = 0
					} else {
						this.isDisabled = 1
					}
				},
				deep: true,
				immediate: true
			},
			radioArray: {
				handler(newVal, oldVal) {
					let tempRule = JSON.stringify(newVal)
					if (tempRule === this.radioSaveData) {
						this.isDisabled5 = 0
					} else {
						this.isDisabled5 = 1
					}
				},
				deep: true,
				immediate: true
			},
			authorityList: {
				handler(newVal, oldVal) {
					let tempRule = JSON.stringify(newVal)
					if (tempRule === this.authoritySaveData) {
						this.isDisabled2 = 0
					} else {
						this.isDisabled2 = 1
					}
				},
				deep: true,
				immediate: true
			},
			rolelist: {
				handler(newVal, oldVal) {
					// 监听选中值变化,更新全选状态
					let allChecked = true
					for (let item of newVal) {
						if (!item.roleischeck) {
							allChecked = false
							break
						}
					}
					this.roleCheckAll = allChecked
					let tempRule = JSON.stringify(newVal)
					if (tempRule === this.rolesaveData) {
						this.isDisabled1 = 0
					} else {
						this.isDisabled1 = 1
					}
				},
				deep: true,
				immediate: true
			},
			permissionlist: {
				handler(newVal, oldVal) {
					// 监听选中值变化,更新全选状态
					let allChecked = true
					for (let item of newVal) {
						if (!item.permissioncheck) {
							allChecked = false
							break
						}
					}
					this.permissionCheckAll = allChecked
					let tempRule = JSON.stringify(newVal)
					if (tempRule === this.permissionsaveData) {
						this.isDisabled3 = 0
					} else {
						this.isDisabled3 = 1
					}
				},
				deep: true,
				immediate: true
			},
/* 			changeunit: {
				handler(newVal, oldVal) {
					let tempRule = JSON.stringify(newVal)
					if (tempRule === this.unitsaveData) {
						this.isDisabled = 0
					} else {
						this.isDisabled = 1
					}
				},
				deep: true,
				immediate: true
			}, */
			staffDoor: {
				handler(newVal, oldVal) {
					for (var j = 0; j < newVal.length - 1; j++) {
						for (var i = 0; i < newVal.length - 1; i++) {
							if (newVal[i] > newVal[i + 1]) {
								var temp = newVal[i]
								newVal[i] = newVal[i + 1]
								newVal[i + 1] = temp
							}
						}
					}
					let tempRule = JSON.stringify(newVal)
					if (tempRule === this.staffDoorSaveData) {
						this.isDisabled2 = 0
					} else {
						this.isDisabled2 = 1
					}
				},
				deep: true,
				immediate: true
			},
			'form.gardenIds': {
				handler(val) {
					// 监听选中值变化,更新全选状态
					this.gardenCheckAll = val.length === this.gardenlist.length
				},
				deep: true
			},
			gardenlist: {
				handler(val) {
					// 监听选中值变化,更新全选状态
					this.gardenCheckAll = this.form.gardenIds.length === val.length
				},
				deep: true
			}
		},
		components: {
			'upload-file': UploadFile
		},
		destroyed() {
			window.localStorage.setItem('wyform', JSON.stringify(this.form))
			window.localStorage.setItem('wysaveData', JSON.stringify(this.saveData))
			window.localStorage.setItem('wyradioSaveData', JSON.stringify(this.radioSaveData))
			window.localStorage.setItem('wyauthoritySaveData', JSON.stringify(this.authoritySaveData))
			window.localStorage.setItem('wyrolesaveData', JSON.stringify(this.rolesaveData))
			window.localStorage.setItem('wypermissionsaveData', JSON.stringify(this.permissionsaveData))
			window.localStorage.setItem('wyunitsaveData', JSON.stringify(this.unitsaveData))
			window.localStorage.setItem('wypermissionlist', JSON.stringify(this.permissionlist))
			window.localStorage.setItem('wyrolelist', JSON.stringify(this.rolelist))
			window.localStorage.setItem('wyauthorityList', JSON.stringify(this.authorityList))
			window.localStorage.setItem('staffdoorauthority', JSON.stringify(this.staffDoorSaveData))
		},
		created() {
			if (this.$route.query.id == undefined || this.$route.query.id == '' || this.$route.query.id == null) {
				if (this.$route.query.id) {
					this.id = this.$route.query.id
					this.selectStaffDoor(this.id)
				}
				this.dept()
				this.getPersonalJobByStaffId()
				this.getPersonalAuthorityByStaffId()
				this.maintainTypes()
				this.gardens()
				// this.form = JSON.parse(window.localStorage.getItem('wyform'))
				if (this.form.avatarUri) {
					this.fileList.push({
						name: '',
						url: this.form.avatarUri
					})
				}
				if (window.localStorage.getItem('wyform')) {
					this.form = JSON.parse(window.localStorage.getItem('wyform'))
				}
				if (window.localStorage.getItem('wypermissionlist')) {
					this.permissionlist = JSON.parse(window.localStorage.getItem('wypermissionlist'))
				}
				if (window.localStorage.getItem('wysaveData')) {
					this.saveData = JSON.parse(window.localStorage.getItem('wysaveData'))
				}
				if (window.localStorage.getItem('wyradioSaveData')) {
					this.radioSaveData = JSON.parse(window.localStorage.getItem('wyradioSaveData'))
				}
				if (window.localStorage.getItem('wyauthoritySaveData')) {
					this.authoritySaveData = JSON.parse(window.localStorage.getItem('wyauthoritySaveData'))
				}
				if (window.localStorage.getItem('wyrolesaveData')) {
					this.rolesaveData = JSON.parse(window.localStorage.getItem('wyrolesaveData'))
				}
				if (window.localStorage.getItem('wypermissionsaveData')) {
					this.permissionsaveData = JSON.parse(window.localStorage.getItem('wypermissionsaveData'))
				}
				if (window.localStorage.getItem('wyunitsaveData')) {
					this.unitsaveData = JSON.parse(window.localStorage.getItem('wyunitsaveData'))
				}
				if (window.localStorage.getItem('wyauthorityList')) {
					this.authorityList = JSON.parse(window.localStorage.getItem('wyauthorityList'))
				}
				if (window.localStorage.getItem('wyrolelist')) {
					this.rolelist = JSON.parse(window.localStorage.getItem('wyrolelist'))
				}
				if (window.localStorage.getItem('staffdoorauthority')) {
					this.staffDoorSaveData = JSON.parse(window.localStorage.getItem('staffdoorauthority'))
				}
				
				console.log('add')
				// console.log(this.staffDoor);
				// console.log(JSON.parse(window.localStorage.getItem('staffdoorauthority')));
			} else {
				console.log('edit')
				if (this.$route.query.id) {
					this.id = this.$route.query.id
					// 点击修改按钮查询详情对象
					this.staffs()
				} else {
					this.form.gender = 1
					this.form.review = 0
					this.form.type = 1
					// 点击新增按钮
					this.fileList = []
					this.backsuccess = 1
				}
				this.dept()
				this.getPersonalJobByStaffId()
				this.getPersonalAuthorityByStaffId()
				this.maintainTypes()
				this.selectStaffDoor(this.id)
				// this.getHouseUnit()
			}
		},
		methods: {
			// 职务全选
			handleRoleCheckAllChange(val) {
				this.rolelist.forEach(item => {
					this.$set(item, 'roleischeck', val)
				})
			},
			// 权限分配全选
			handlePermissionCheckAllChange(val) {
				this.permissionlist.forEach(item => {
					this.$set(item, 'permissioncheck', val)
				})
			},
			// 所属小区全选
			handleGardenCheckAllChange(val) {
				if (val) {
					// 全选 - 将所有小区id添加到选中数组
					this.form.gardenIds = this.gardenlist.map(item => item.id)
				} else {
					// 取消全选 - 清空选中数组
					this.form.gardenIds = []
				}
				// 同步更新门禁权限
				if (val) {
					this.staffDoor = this.gardenlist.map(item => item.id)
				} else {
					this.staffDoor = []
				}
			},
			// 选择默认头像
			selectDefaultAvatar(item, index) {
				this.defaultAvatarIndex = index
				this.form.avatarUri = item
				this.fileList = []
			},
			// 点击手动上传头像
			handUpload () {
				this.showUpload = true
			},
			resetPassword() {
						let loading = this.$loading()
            let params = { 
             mobile: this.form.userName
            }
            this.$patch(`/selfPassword`, params).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  // this.$message.success('重置成功')
									  this.$message.success(this.$i18n.t('lang.lab_reset_success'))
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
			},
			/* changeYear() {
				if (this.id && this.form.targetYear) {
					let date = new Date(this.form.targetYear)
					let year = date.getFullYear()
					let loading = this.$loading()
					this.$get(`/sklStaffTargetByStaffYear`, {
						staffId: this.id,
						targetYear: year,
					}).then(res => {
						loading.close()
						if (res.errCode == 0) {
							this.$set(this.form, 'month1', res.targetAmount1 == 0 ? '' : res.targetAmount1)
							this.$set(this.form, 'month2', res.targetAmount2 == 0 ? '' : res.targetAmount2)
							this.$set(this.form, 'month3', res.targetAmount3 == 0 ? '' : res.targetAmount3)
							this.$set(this.form, 'month4', res.targetAmount4 == 0 ? '' : res.targetAmount4)
							this.$set(this.form, 'month5', res.targetAmount5 == 0 ? '' : res.targetAmount5)
							this.$set(this.form, 'month6', res.targetAmount6 == 0 ? '' : res.targetAmount6)
							this.$set(this.form, 'month7', res.targetAmount7 == 0 ? '' : res.targetAmount7)
							this.$set(this.form, 'month8', res.targetAmount8 == 0 ? '' : res.targetAmount8)
							this.$set(this.form, 'month9', res.targetAmount9 == 0 ? '' : res.targetAmount9)
							this.$set(this.form, 'month10', res.targetAmount10 == 0 ? '' : res.targetAmount10)
							this.$set(this.form, 'month11', res.targetAmount11 == 0 ? '' : res.targetAmount11)
							this.$set(this.form, 'month12', res.targetAmount12 == 0 ? '' : res.targetAmount12)
						}
					}, err => {
						console.log(err)
						this.$message.error(err)
					})
				} else {
					this.form.month1 = ''
					this.form.month2 = ''
					this.form.month3 = ''
					this.form.month4 = ''
					this.form.month5 = ''
					this.form.month6 = ''
					this.form.month7 = ''
					this.form.month8 = ''
					this.form.month9 = ''
					this.form.month10 = ''
					this.form.month11 = ''
					this.form.month12 = ''
				}
			},
			targetKeyup1() {
				// 仅保留数字和"."
				this.form.month1 = this.form.month1.replace(/[^\d]/g, '')
				// 首位是0的话去掉
				if (this.form.month1.indexOf('.') < 0 && this.form.month1 != '') {
					this.form.month1 = parseFloat(this.form.month1)
				}
			},
			targetKeyup2() {
				this.form.month2 = this.form.month2.replace(/[^\d]/g, '')
				if (this.form.month2.indexOf('.') < 0 && this.form.month2 != '') {
					this.form.month2 = parseFloat(this.form.month2)
				}
			},
			targetKeyup3() {
				this.form.month3 = this.form.month3.replace(/[^\d]/g, '')
				if (this.form.month3.indexOf('.') < 0 && this.form.month3 != '') {
					this.form.month3 = parseFloat(this.form.month3)
				}
			},
			targetKeyup4() {
				this.form.month4 = this.form.month4.replace(/[^\d]/g, '')
				if (this.form.month4.indexOf('.') < 0 && this.form.month4 != '') {
					this.form.month4 = parseFloat(this.form.month4)
				}
			},
			targetKeyup5() {
				this.form.month5 = this.form.month5.replace(/[^\d]/g, '')
				if (this.form.month5.indexOf('.') < 0 && this.form.month5 != '') {
					this.form.month5 = parseFloat(this.form.month5)
				}
			},
			targetKeyup6() {
				this.form.month6 = this.form.month6.replace(/[^\d]/g, '')
				if (this.form.month6.indexOf('.') < 0 && this.form.month6 != '') {
					this.form.month6 = parseFloat(this.form.month6)
				}
			},
			targetKeyup7() {
				this.form.month7 = this.form.month7.replace(/[^\d]/g, '')
				if (this.form.month7.indexOf('.') < 0 && this.form.month7 != '') {
					this.form.month7 = parseFloat(this.form.month7)
				}
			},
			targetKeyup8() {
				this.form.month8 = this.form.month8.replace(/[^\d]/g, '')
				if (this.form.month8.indexOf('.') < 0 && this.form.month8 != '') {
					this.form.month8 = parseFloat(this.form.month8)
				}
			},
			targetKeyup9() {
				this.form.month9 = this.form.month9.replace(/[^\d]/g, '')
				if (this.form.month9.indexOf('.') < 0 && this.form.month9 != '') {
					this.form.month9 = parseFloat(this.form.month9)
				}
			},
			targetKeyup10() {
				this.form.month10 = this.form.month10.replace(/[^\d]/g, '')
				if (this.form.month10.indexOf('.') < 0 && this.form.month10 != '') {
					this.form.month10 = parseFloat(this.form.month10)
				}
			},
			targetKeyup11() {
				this.form.month11 = this.form.month11.replace(/[^\d]/g, '')
				if (this.form.month11.indexOf('.') < 0 && this.form.month11 != '') {
					this.form.month11 = parseFloat(this.form.month11)
				}
			},
			targetKeyup12() {
				this.form.month12 = this.form.month12.replace(/[^\d]/g, '')
				if (this.form.month12.indexOf('.') < 0 && this.form.month12 != '') {
					this.form.month12 = parseFloat(this.form.month12)
				}
			}, */
			// 获取组件值
			getFile(e) {
				this.form.avatarUri = e
				this.$refs.avatarUri.clearValidate()
				this.defaultAvatarIndex = ''
			},
			// 移除图片
			removeFile(e) {
				this.fileList = []
				this.form.avatarUri = ''
				this.defaultAvatarIndex = ''
			},
			// 编辑时判断
			checkEdit() {
				if (this.id != '') {
					this.fileList = []
					this.fileList.length = 0
					this.form.avatarUri = ''
				}
			},
			// 职责项单选变化监控--暂无该需求
			handleRadioChanges(index, item) {
				// index:选中的职责选项下标，item:选中的职责选项
				let data = {
					id: '',
					name: ''
				}
				data.id = item.AuthorityOptionId
				data.name = item.OptionName
				// data.value = parseInt(item.value)
				this.shoarr.push(data) // 将该项的item存到实现准备好的数组shoarr
				let myarr = this.shoarr
				for (var i = 0; i < myarr.length; i++) {
					for (var j = i + 1; j < myarr.length; j++) {
						if (myarr[i].id == myarr[j].id) {
							myarr.splice(i, 1)
							j--
						}
					}
				} // 数组去重，以该项最后一个选中为准
				this.shoarr = myarr
			},
			keyBAuserName() {
				// 仅保留数字和"."
				this.form.userName = this.form.userName.replace(/[^\d]/g, '')
				// 首位是0的话去掉
				if (this.form.userName.indexOf('.') < 0 && this.form.userName != '') {
					this.form.userName = parseFloat(this.form.userName)
				}
			},
			keyBA() {
				// 仅保留数字和"."
				this.form.workYears = this.form.workYears.replace(/[^\d]/g, '')
				// 首位是0的话去掉
				if (this.form.workYears.indexOf('.') < 0 && this.form.workYears != '') {
					this.form.workYears = parseFloat(this.form.workYears)
				}
			},
			// 监听关闭dialog
			/* handleDialogClosed() {
				this.units = []
				this.changeunit = []
				this.unit = this.$refs.tree.getCheckedNodes()
				for (var i = 0; i < this.unit.length; i++) {
					if (this.unit[i].nodes) {} else {
						this.units.push(this.unit[i])
					}
				}
				for (var j = 0; j < this.units.length; j++) {
					this.changeunit.push(this.units[j].unitId)
				}
			}, */
			// 管辖列表
			/* HouseUnit() {
				this.getHouseUnit()
				this.show = true
			}, */
			// 管辖list
			/* getHouseUnit() {
				let id = this.id
				if (id === '') {
					id = 0
				}
				if (this.unitnum === 0) {
					let loading = this.$loading()
					this.$get(
						`/getHouseUnit?parentId=${this.gardenId}&staffId=${id}&operateFlag=true`
					).then(
						res => {
							loading.close()
							if (res && res.errCode === 0) {
								this.unitnum++
								this.unitlist = res.list
								// console.log(JSON.stringify(this.unitlist))
								for (var i = 0; i < this.unitlist.length; i++) {
									if (this.unitlist[i].state.disabled === true) {
										this.unitlist[i].disabled = true
									}
									if (
										this.unitlist[i].nodes &&
										this.unitlist[i].nodes.length > 0
									) {
										for (var j = 0; j < this.unitlist[i].nodes.length; j++) {
											if (this.unitlist[i].nodes[j].state.disabled === true) {
												this.unitlist[i].nodes[j].disabled = true
											}
											if (this.unitlist[i].nodes[j].state.checked === true) {
												this.unitlistcheck.push(this.unitlist[i].nodes[j].unitId)
											}
										}
									}
								}
								this.unitsaveData = JSON.stringify(this.unitlistcheck)
							}
						},
						error => {
							loading.close()
							this.$message.error(error)
						}
					)
				}
			}, */
			// 返回list页面
			jump() {
				this.$router.push({
					name: 'propertyManageList'
				})
			},
			// 部门list
			dept() {
				let loading = this.$loading()
				this.$get(`/depts/?pageNo=1&pageSize=999&gardenId=${this.gardenId}`).then(
					res => {
						loading.close()
						if (res && res.errCode === 0) {
							this.deptlist = res.list
						}
					},
					error => {
						loading.close()
						this.$message.error(error)
					}
				)
			},
			// 清空
			resetForm(formName) {
				this.clears = true
				// this.unitnum = 0
				// this.unit = [] // 区域空
				this.fileList = [] // 图片列表清空
				this.form.pwd = ''
				this.form.userName = ''
				this.form.gender = 1
				this.form.review = 0
				this.form.type = 1
				this.form.idNo = ''
				this.form.avatarUri = ''
				this.form.dept = ''
				this.form.workYears = ''
				this.form.joinDate = ''
				this.form.note = ''
				this.defaultAvatarIndex = ''
				this.form.jobName = ''
				for (var i = 0; i < this.rolelist.length; i++) {
					this.$set(this.rolelist[i], 'roleischeck', false)
				}
				for (var h = 0; h < this.authorityList.length; h++) {
					for (var k = 0; k < this.authorityList[h].children.length; k++) {
						if (this.authorityList[h].AuthorityType === 1) {
							this.$set(this.authorityList[h].children[k], 'CheckFlag', false)
						}
					}
				}
				this.radioArray = []
				this.form.gardenIds = []
				for (var j = 0; j < this.permissionlist.length; j++) {
					this.$set(this.permissionlist[j], 'permissioncheck', false)
				}
				setTimeout(() => {
					this.$refs.form.clearValidate()
				}, 0)
			},
			// 数组排序用
			sequence(a, b) {
				return a - b
			},
			// 编辑查询详情
			staffs() {
				let loading = this.$loading()
				this.$get(
					`/staffs/${this.id}?currentGarden=${this.$store.getters.gardenId}`
				).then(
					res => {
						loading.close()
						if (res && res.errCode === 0) {
							this.form = res
							this.form.pwd = this.form.pwd.substring(0, 6)
							for (var i = 0; i < this.form.gardenIds.length; i++) {
								if (this.form.gardenIds[i] != null) {
									this.gardenIds.push(parseInt(this.form.gardenIds[i]))
								}
							}
							this.form.gardenIds = this.gardenIds.sort(this.sequence)
							if (
								this.form.avatarUri &&
								this.form.avatarUri != null &&
								this.form.avatarUri != ''
							) {
								if (this.form.avatarUri == 'https://yunnanyihe.oss-cn-heyuan.aliyuncs.com/2025/03/06/cecc6de6-585a-420a-b03b-263587ff7216.png') {
									this.defaultAvatarIndex = 0
								} else if (this.form.avatarUri == 'https://yunnanyihe.oss-cn-heyuan.aliyuncs.com/2025/03/06/6a2a4d7e-c45a-4387-b4d5-233380597880.png') {
									this.defaultAvatarIndex = 1
								} else if (this.form.avatarUri == 'https://yunnanyihe.oss-cn-heyuan.aliyuncs.com/2025/03/06/b519bf7e-c3f5-4cbf-abff-00c89c13bf24.png') {
									this.defaultAvatarIndex = 2
								} else if (this.form.avatarUri == 'https://yunnanyihe.oss-cn-heyuan.aliyuncs.com/2025/03/06/f4f5b367-0537-465f-bdf4-1ff5342ecaa6.png') {
									this.defaultAvatarIndex = 3
								} else if (this.form.avatarUri == 'https://yunnanyihe.oss-cn-heyuan.aliyuncs.com/2025/03/06/34b9fd21-c3b1-4628-85a0-71f6c2c4ccc2.png') {
									this.defaultAvatarIndex = 4
								} else if (this.form.avatarUri == 'https://yunnanyihe.oss-cn-heyuan.aliyuncs.com/2025/03/06/e0d3509e-d492-490c-9ddb-6687e22cbf96.png') {
									this.defaultAvatarIndex = 5
								} else if (this.form.avatarUri == 'https://yunnanyihe.oss-cn-heyuan.aliyuncs.com/2025/03/06/d9d9f3a6-19fc-424e-804e-eddb5676b3ba.png') {
									this.defaultAvatarIndex = 6
								} else {
									this.fileList.push({
									name: '',
									url: this.form.avatarUri
								})
								this.showUpload = true
								}
							} else {
								this.fileList = []
							}
							this.saveData = JSON.stringify(this.form)
							this.backsuccess = 1
							
							this.selectStaffDoor(this.id)
						}
					},
					error => {
						loading.close()
						this.$message.error(error)
					}
				)
			},
			// 权限分配
			maintainTypes() {
				let loading = this.$loading()
				this.$get(
					`/maintainTypes?type=1&pageNo=1&pageSize=999&gardenId=${this.gardenId}`
				).then(
					res => {
						loading.close()
						if (res && res.errCode === 0) {
							this.permissionlist = res.list

							if (this.form.maintainTypeIds) {
								if (
									this.form.maintainTypeIds.length > 0 &&
									this.backsuccess != 0
								) {
									this.permissionlist.map(item => {
										for (var j = 0; j < this.form.maintainTypeIds.length; j++) {
											if (item.id === parseInt(this.form.maintainTypeIds[j])) {
												this.$set(item, 'permissioncheck', true) // 这里，给对象添加属性，用$set方法。
												break
											} else {
												this.$set(item, 'permissioncheck', false) // 这里，给对象添加属性，用$set方法。
											}
										}
									})
								}
							}
							this.permissionsaveData = JSON.stringify(this.permissionlist)
						}
					},
					error => {
						loading.close()
						this.$message.error(error)
					}
				)
			},
			// 岗位属性
			getPersonalAuthorityByStaffId() {
				let loading = this.$loading()
				if (this.id === '') {
					this.$get(
						`/getPersonalAuthorityByStaffId?opeatePeople=${this.staffId}`
					).then(
						res => {
							loading.close()
							if (res && res.errCode === 0) {
								this.authorityList = res.result
								for (var h = 0; h < this.authorityList.length; h++) {
									for (
										var k = 0; k < this.authorityList[h].children.length; k++
									) {
										if (this.authorityList[h].AuthorityType === 1) {
											if (this.authorityList[h].children[k].CheckFlag === 1) {
												this.$set(
													this.authorityList[h].children[k],
													'CheckFlag',
													true
												) // 这里，给对象添加属性，用$set方法
											} else {
												this.$set(
													this.authorityList[h].children[k],
													'CheckFlag',
													false
												) // 这里，给对象添加属性，用$set方法
											}
										} else {
											if (this.authorityList[h].children[k].CheckFlag === 1) {
												this.radioArray.push(this.authorityList[h].children[k])
											}
										}
									}
								}
								// 这是用来保存数据 用来保存就一进来取到的数据，不会去修改它
								this.radioSaveData = JSON.stringify(this.radioArray)
								this.authoritySaveData = JSON.stringify(this.authorityList)
							}
						},
						error => {
							loading.close()
							this.$message.error(error)
						}
					)
				} else {
					this.$get(
						`/getPersonalAuthorityByStaffId?opeatePeople=${this.staffId}&staffId=${this.id}`
					).then(
						res => {
							loading.close()
							if (res && res.errCode === 0) {
								this.authorityList = res.result
								for (var h = 0; h < this.authorityList.length; h++) {
									for (
										var k = 0; k < this.authorityList[h].children.length; k++
									) {
										if (this.authorityList[h].AuthorityType === 1) {
											if (this.authorityList[h].children[k].CheckFlag === 1) {
												this.$set(
													this.authorityList[h].children[k],
													'CheckFlag',
													true
												) // 这里，给对象添加属性，用$set方法
											} else {
												this.$set(
													this.authorityList[h].children[k],
													'CheckFlag',
													false
												) // 这里，给对象添加属性，用$set方法
											}
										} else {
											if (this.authorityList[h].children[k].CheckFlag === 1) {
												this.radioArray.push(this.authorityList[h].children[k])
											}
										}
									}
								}
								this.radioSaveData = JSON.stringify(this.radioArray)
								this.authoritySaveData = JSON.stringify(this.authorityList)
							}
						},
						error => {
							loading.close()
							this.$message.error(error)
						}
					)
				}
			},
			// 保存列表成功后调三个接口岗位
			// 岗位管理保存
			savePersonAuthority(staffId) {
				let params = {
					staffId: staffId,
					opeateStaffId: this.staffId
				}
				let authorityId = {}
				for (var h = 0; h < this.authorityList.length; h++) {
					authorityId[h] = {}
					for (var k = 0; k < this.authorityList[h].children.length; k++) {
						if (this.authorityList[h].AuthorityType === 1) {
							if (this.authorityList[h].children[k].CheckFlag === true) {
								authorityId[h][k] = this.authorityList[h].children[k].AuthorityOptionId
							}
						} else {
							var id = this.authorityList[h].children[k].AuthorityOptionId
							this.radioArray.forEach(function(item) {
								if (item.AuthorityOptionId === id) {
									authorityId[h][k] = id
								}
							})
						}
					}
				}
				params.model = authorityId
				let loading = this.$loading()
				// 为了匹配Swagger标签，content-type传递application/json格式
				this.$postJson(`/savePersonAuthority`, JSON.stringify(params)).then(
					res => {
						loading.close()
						if (res && res.errCode === 0) {}
					},
					error => {
						loading.close()
						this.$message.error(error)
					}
				)
			},
			savePersonMunu(staffId) {
				let params = {
					staffId: staffId,
					opeatePeople: this.staffId
				}
				let loading = this.$loading()
				this.$postJson(`/savePersonMunu`, JSON.stringify(params)).then(
					res => {
						loading.close()
						if (res && res.errCode === 0) {}
					},
					error => {
						loading.close()
						this.$message.error(error)
					}
				)
			},
			savePersonJob(staffId) {
				let params = {
					staffId: staffId,
					opeatePeople: this.staffId
				}
				let jobid = {}
				for (var i = 0; i < this.rolelist.length; i++) {
					if (this.rolelist[i].roleischeck === true) {
						jobid[i] = this.rolelist[i].Id
					}
				}
				params.jobStaff = jobid

				let loading = this.$loading()
				this.$postJson(`/savePersonJob`, JSON.stringify(params)).then(
					res => {
						loading.close()
						if (res && res.errCode === 0) {}
					},
					error => {
						loading.close()
						this.$message.error(error)
					}
				)
			},

			saveStaffUser(staffId) {
				let loading = this.$loading()
				this.$get(`/roomOwnerStaff?staffId=` + staffId + `&operPeople=` + this.staffId).then(
					res => {
						loading.close()
						if (res && res.errCode === 0) {}
					},
					error => {
						loading.close()
						this.$message.error(error)
					}
				)
			},
			//  选择职务
			getPersonalJobByStaffId() {
				let loading = this.$loading()
				this.$get(
					`/getPersonalJobByStaffId?staffId=${this.id}&opeatePeople=${this.staffId}`
				).then(
					res => {
						loading.close()
						if (res && res.errCode === 0) {
							this.rolelist = res.result
							this.rolelist.map(item => {
								if (item.CheckFlag === 1) {
									this.$set(item, 'roleischeck', true) // 这里，给对象添加属性，用$set方法。
									return item
								} else {
									this.$set(item, 'roleischeck', false) // 这里，给对象添加属性，用$set方法。
									return item
								}
							})
							this.rolesaveData = JSON.stringify(this.rolelist)
						}
					},
					error => {
						loading.close()
						this.$message.error(error)
					}
				)
			},
			// 检查手机号
			async checkMobileOrUserNameIsExist() {
				let loading = this.$loading()
				let url = ''
				if (this.id === '') {
					url = `/checkMobileOrUserNameIsExist?mobile=${this.form.userName}`
				} else {
					url = `/checkMobileOrUserNameIsExist?mobile=${this.form.mobile}`
				}
				let res = await this.$get(
					url
				)
				loading.close()
				return new Promise(function(resolve, reject) {
					if (!res) {
						reject(res.error)
						return this.$message.error(res.error)
					}
					if (res.flag === true) {
						resolve(true)
					} else {
						resolve(false)
					}
				})
			},
			// 保存
			save(formName) {
				this.$refs[formName].validate(valid => {
					if (valid) {
					/* 	if (this.units && this.units.length > 0) {
							for (var s = 0; s < this.units.length; s++) {
								this.units[s].state.checked = true
								this.units[s].state.expanded = false
								this.units[s].state.selected = false
								this.units[s].parentId = this.gardenId
							}
						} */
						this.maintainTypechecks = []
						for (var i = 0; i < this.permissionlist.length; i++) {
							if (this.permissionlist[i].permissioncheck === true) {
								this.maintainTypechecks.push(this.permissionlist[i].id)
							}
						}
						if (this.id === '') {
							let params = {
								recFlag: 0,
								userName: this.form.userName,
								pwd: this.form.pwd,
								gender: this.form.gender,
								review: this.form.review,
								// type: this.form.type,
								idNo: this.form.jobName + '-' + this.form.idNo,
								dept: this.form.dept,
								workYears: this.form.workYears,
								note: this.form.note,
								dateStr: this.form.joinDate,
								mobile: this.form.userName,
								maintainTypeIds: this.maintainTypechecks.toString(), // 权限分配id
								gardenIds: this.form.gardenIds.toString(), // 小区id
								gardenId: this.gardenId,
								avatarUri: this.form.avatarUri,
								// unit: this.units.length > 0 ? JSON.stringify(this.units) : '',
								operPeople: this.staffId,
								operationNum: this.form.operationNum
							}
							/* if (this.form.type === 2) {
								if (this.units.length === 0) {
									this.$message.error(this.$i18n.t('请选择管辖区域'))
									return
								}
							} */
							let loading = this.$loading()
							this.$postJson(`/staffs`, params).then(
								res => {
									console.log(res)
									loading.close()
									if (res && res.errCode === 0) {
										this.$message.success(this.$i18n.t('lang.lab_save_success'))
										this.savePersonAuthority(res.staffId)
										this.savePersonMunu(res.staffId)
										this.savePersonJob(res.staffId)
										// this.saveStaffUser(res.staffId)
										var index = this.$keepAlive.indexOf('/manage/main.staff')
										if (index > -1) {
											this.$keepAlive.splice(index, 1)
										}
										this.$router.push({
											name: 'propertyManageList'
										})
										/* 获取返回的staffId 添加门禁权限 */
										this.$postJson(`/addStaffDoorAuthority`, {
											staffId: res.staffId,
											gardenIdList: this.staffDoor
										}).then(res => {
											loading.close()
										}, err => {
											loading.close()
											this.$message.error(err)
										})
										/* 员工目标值 */
										/* let date = new Date(this.form.targetYear)
										let year = date.getFullYear()
										this.$post(`/sklStaffTarget`, {
											staffId: res.staffId,
											targetYear: year,
											targetAmount1: this.form.month1 == '' ? 0 : this.form.month1,
											targetAmount2: this.form.month2 == '' ? 0 : this.form.month2,
											targetAmount3: this.form.month3 == '' ? 0 : this.form.month3,
											targetAmount4: this.form.month4 == '' ? 0 : this.form.month4,
											targetAmount5: this.form.month5 == '' ? 0 : this.form.month5,
											targetAmount6: this.form.month6 == '' ? 0 : this.form.month6,
											targetAmount7: this.form.month7 == '' ? 0 : this.form.month7,
											targetAmount8: this.form.month8 == '' ? 0 : this.form.month8,
											targetAmount9: this.form.month9 == '' ? 0 : this.form.month9,
											targetAmount10: this.form.month10 == '' ? 0 : this.form.month10,
											targetAmount11: this.form.month11 == '' ? 0 : this.form.month11,
											targetAmount12: this.form.month12 == '' ? 0 : this.form.month12,
										}).then(res => {
											console.log(res)
										}, err => {
											this.$message.error(err)
										}) */
									}
								},
								error => {
									loading.close()
									console.log(error)
									this.$message.error(error)
								}
							)
						} else {
							let loading = this.$loading()
							let params = {
								recFlag: 0,
								id: this.id,
								userName: this.form.mobile,
								// pwd: this.form.pwd,
								gender: this.form.gender,
								review: this.form.review,
								type: this.form.type,
								idNo: this.form.idNo,
								dept: this.form.dept,
								workYears: this.form.workYears,
								note: this.form.note,
								dateStr: this.form.joinDate,
								mobile: this.form.mobile,
								maintainTypeIds: this.maintainTypechecks.toString(), // 权限分配id
								gardenIds: this.form.gardenIds.toString(), // 小区id
								gardenId: this.gardenId,
								avatarUri: this.form.avatarUri,
								// unit: this.units.length > 0 ? JSON.stringify(this.units) : '',
								operPeople: this.staffId,
								operationNum: this.form.operationNum,
							}
							/* if (this.form.type === 2) {
								if (this.unitlist.length === 0 || this.unitlistcheck.length === 0) {
									this.$message.error(this.$i18n.t('请选择管辖区域'))
									return
								}
							} */
							this.$patch(`/staffs/${this.id}`, params).then(
								res => {
									loading.close()
									if (res && res.errCode === 0) {
										this.$message.success(
											this.$i18n.t('lang.lab_modify_success')
										)
										this.savePersonAuthority(res.staffId)
										this.savePersonMunu(res.staffId)
										this.savePersonJob(res.staffId)
										// this.saveStaffUser(res.staffId)
										var index = this.$keepAlive.indexOf('/manage/main.staff')
										if (index > -1) {
											this.$keepAlive.splice(index, 1)
										}
										this.$router.push({
											name: 'propertyManageList'
										})
										this.$postJson(`/editStaffDoorAuthority`, {
											staffId: this.id,
											gardenIdList: this.staffDoor
										}).then(res => {
											loading.close()
										}, err => {
											loading.close()
											this.$message.error(err)
										})
										/* 员工目标值 */
										/* let date = new Date(this.form.targetYear)
										let year = date.getFullYear()
										this.$post(`/sklStaffTarget`, {
											staffId: res.staffId,
											targetYear: year,
											targetAmount1: this.form.month1 == '' ? 0 : this.form.month1,
											targetAmount2: this.form.month2 == '' ? 0 : this.form.month2,
											targetAmount3: this.form.month3 == '' ? 0 : this.form.month3,
											targetAmount4: this.form.month4 == '' ? 0 : this.form.month4,
											targetAmount5: this.form.month5 == '' ? 0 : this.form.month5,
											targetAmount6: this.form.month6 == '' ? 0 : this.form.month6,
											targetAmount7: this.form.month7 == '' ? 0 : this.form.month7,
											targetAmount8: this.form.month8 == '' ? 0 : this.form.month8,
											targetAmount9: this.form.month9 == '' ? 0 : this.form.month9,
											targetAmount10: this.form.month10 == '' ? 0 : this.form.month10,
											targetAmount11: this.form.month11 == '' ? 0 : this.form.month11,
											targetAmount12: this.form.month12 == '' ? 0 : this.form.month12,
										}).then(res => {
											console.log(res)
										}, err => {
											this.$message.error(err)
										}) */
									}
								},
								error => {
									loading.close()
									this.$message.error(error)
								}
							)
						}
						// console.log(this.staffDoor)
					} else {
						this.$message.error('表单有必填项未填写，请检查后保存')
					}
				})
			},
			// 小区下拉
			gardens() {
				let loading = this.$loading()
				this.$get(`/gardensByStaffId`).then(
					res => {
						loading.close()
						if (res && res.errCode === 0) {
							this.gardenlist = res.list.filter(item => item.id !== 0)
						}
					},
					error => {
						loading.close()
						this.$message.error(error)
					}
				)
			},
			selectStaffDoor(staffId) {
				let loading = this.$loading()
				this.$postJson(`/selectAllStaffDoorAuthority`, {
					staffId: staffId
				}).then(res => {
					if (res.list.length == 0) {
						this.staffDoor = this.form.gardenIds
					} else {
						this.staffDoor = res.list
					}
					this.staffDoorSaveData = JSON.stringify(this.staffDoor)
				}, err => {
					loading.close()
					this.$message.error(err)
				})
			},
			gardenIdChange(value) {
				var gardenId = event.target.value
				if (value) {
					let isAdd = false
					for (var i = 0; i < this.staffDoor.length; i++) {
						if (this.staffDoor[i] == gardenId) {
							isAdd = true
							break
						}
					}
					if (!isAdd) this.staffDoor.push(parseInt(gardenId))
				}
			}
		}
	}
</script>

<style lang="scss">
	.addpropertyManage .formcontent {
		width: 30vw !important;
	}
	.addpropertyManage .formcontent1{
		width: 60vw !important;
	}
	.addpropertyManage .el-date-editor,.addpropertyManage .el-select{
		width: 100%;
	}

	.addpropertyManage .el-collapse-item__header {
		padding-left: 46px;
	}

	.addpropertyManage .padtop-10 {
		padding-top: 10px;
	}

	.addpropertyManage .el-collapse-item__header {
		border-bottom: 0px;
	}

	.addpropertyManage .el-collapse {
		border-top: 0px;
		border-bottom: 0px;
	}

	.addpropertyManage .el-collapse-item__wrap {
		border-bottom: 0px;
	}

	.addpropertyManage .trees .el-checkbox {
		width: 20px;
	}

	.addpropertyManage .trees {
		height: 500px;
		overflow-y: auto;
	}

	.addpropertyManage .trees::-webkit-scrollbar {
		width: 10px;
		height: 1px;
	}

	.addpropertyManage .trees::-webkit-scrollbar-thumb {
		border-radius: 4px;
		background: rgba(144, 147, 153, 0.3);
	}

	.addpropertyManage {
		.el-scrollbar__wrap {
			margin-bottom: -15px !important;
			margin-right: -10px !important;
		}
	}

	// 解决多选框长度过长显示异常问题
	.addpropertyManage {
		.chooseActive {
			label {
				.el-checkbox__label {
					max-width: 155px;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
					vertical-align: middle; // 纵向居中
				}
			}
		}
	}

	.addpropertyManage .el-checkbox,
	.el-checkbox-button__inner,
	.el-radio {
		width: 160px;
	}
	.noStyle{
		position: absolute;
		top: 13px;
		right: -20px;
    border: none!important;
    padding: 0!important;
  }
  .noStyle:hover{
    background-color: #fff!important;
  }

/* 	.garden .targetMonth {
		width: 200px;
	}

	.targetLabel {
		margin: 10px;
		display: inline-block;
	} */
	.defaultAvatarList{
		display: flex;
		flex-wrap: wrap;
		.defaultAvatarBox{
			width: 148px;
			height: 148px;
			margin-right: 10px;
			position: relative;
			margin-bottom: 10px;
			padding-bottom: 40px;
      text-align: center;
		}
		.selectIcon{
			width: 52px;
			height: 52px;
			position: absolute;
      right: -6px;
      top: -9px;
      z-index: 100;
		}
		.selectFont{
			color: #13ce66;
			font-weight: bold;
		}
		.defaultAvatarImg{
			width: 100%;
			height: 100%;
		}
		.defaultAvatarName{
			margin-top: -15px;
		}
		.handUpload{
			width: 148px;
			height: 148px;
			line-height: 148px;
			border: 1px dashed #c0ccda;
			text-align: center;
			color: #c0ccda;
			font-weight: bold;
			font-size: 16px;
		}
		.handUpload:hover{
			border: 1px dashed #00b1c3;
			color: #00b1c3;
		}
	}
	.addpropertyManage {
		.el-collapse {
			/* 折叠面板头部样式 */
			.el-collapse-item__header {
				/* 添加提示文字 */
				&::before {
					content: "点击展开";
					position: absolute;
					right: 40px;
					color: #00b1c3;
					font-size: 12px;
					font-weight: normal;
				}
					
				/* 添加箭头动画 */
				.el-collapse-item__arrow {
					font-size: 16px;
					transition: transform .3s;
				}
					
				/* 鼠标悬停效果 */
				&:hover {
					cursor: pointer;
				}
			}
	
			/* 展开状态样式 */
			.is-active {
				.el-collapse-item__header {
						
					&::before {
						content: "点击收起";
					}
				}
			}
		}
	}
</style>
